<template>

    <div class="inc_right">
        <template v-if="sideright.content != '目前尚未查詢到文章內容'">
            <div class="tchtopinf">
                <div class="tchimg">
                    <img :src="'/filestore' + filepath" @error="handleImgError" :alt="title + '教授照片'">
                </div>
                <div class="tchintrd">
                    <div class="tchintrd_st">{{ job }}</div>
                    <div class="tchintrd_h1">{{ title }}</div>
                    <div class="tchintrd_intro">
                        <div class="tchintrd_phone" v-if="phone != '' && now_special.phone != '' ">{{ now_special.phone+'：' + phone }}</div>
                        <template v-if="PJ_ID == 'PJ20250503' || PJ_ID == 'PJ20250506'">
                            <div class="tchintrd_mark" v-if="fax != ''  && now_special.fax != '' ">{{ fax  +" "+  now_special.fax }}</div>
                        </template>
                        <template v-else>
                            <div class="tchintrd_fax" v-if="fax != ''  && now_special.fax != '' ">{{ now_special.fax +'：' + fax }}</div>

                        </template>
                        <div class="tchintrd_email" v-if="email != '' && now_special.email != '' ">{{ now_special.email +'：' + email }}</div>
                    </div> 
                </div>
            </div>
        </template>
        <template v-else>
            <div class="tchtopinf">
                <div class="tchimg">
                    <img src="/images/therpc_01.jpg"  :alt="title + '教授照片'">
                </div>
                <div class="tchintrd">
                    <div class="tchintrd_st"></div>
                    <div class="tchintrd_h1">目前尚無相關資料，敬請期待！</div>
                </div>
            </div>
            <div class="tchintrall">
            </div>
        </template>
        <div class="tchintrall" >
            <div class="tchtrablock" v-if="research.length > 0">
                <div class="tchbk_title">{{ now_special.research }}</div>
                <div class="tchbk_txtall">
                    <div class="tchbk_txt" v-for="(item, index) in research" v-bind:key="index">
                        {{ item }}
                    </div>
                </div>
            </div>
            <div class="tchtrablock" v-if="offered.length > 0">
                <div class="tchbk_title">{{ now_special.offered }}</div>
                <div class="tchbk_txtall">
                    <div class="tchbk_txt" v-for="(item, index) in offered" v-bind:key="index">
                        {{ item }}
                    </div>
                </div>
            </div>
            <div class="tchtrablock" v-if="(now_special.PJ_ID != 'PJ20250503' && now_special.PJ_ID != 'PJ20250506') && educational.length > 0">
                <div class="tchbk_title">{{ now_special.educational }}</div>
                <div class="tchbk_txtall">
                    <div class="tchbk_txt50" v-for="(item, index) in educational" v-bind:key="index">
                        {{ item }}
                    </div>
                </div>
            </div>
            <div class="tchtrablock" v-if="service.length > 0">
                <div class="tchbk_title">{{ now_special.service }}</div>
                <div class="tchbk_txtall">
                    <div class="tchbk_txt50" v-for="(item, index) in service" v-bind:key="index">
                        {{ item }}
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
export default {
    components: {

    },
    data() {
        return {
            //上架時間
            onlineDate: "",
            //上架位置
            onlinePlace: "",
            //文章標題
            title: "",
            //文章內容
            content: "",
            //附件下載清單
            fileData: [],
            //是否使用標籤
            useTag: true,
            //上方次類別
            sublist: {},

            filepath: "/",
            job: "",
            phone: "",
            fax: "",
            email: "",
            research: [],
            offered: [],
            educational: [],
            service: [],

            special_list: [
                {
                    //專任教授
                    PJ_ID: "PJ20250501",
                    phone: "電話",
                    fax: "傳真",
                    email: "E-mail",
                    research: "研究領域",
                    offered: "開設課程",
                    educational:"學歷",
                    service:"研究室",
                },
                {
                    //兼任教授
                    PJ_ID: "PJ20250502",
                    phone: "",
                    fax: "",
                    email: "E-mail",
                    research:"研究領域",
                    offered:"開設課程",
                    educational:"現職",
                    service:"經歷",
                },
                {
                    //退休教授
                    PJ_ID: "PJ20250503",
                    phone: "",
                    fax: "退休",
                    email: "",
                    research:"研究領域",
                    offered:"開設課程",
                    educational:"",
                    service:"主要經歷",
                },
                {
                    //行政人員
                    PJ_ID: "PJ20250504",
                    phone: "電話",
                    fax: "",
                    email: "E-mail",
                    research:"研究領域",
                    offered:"開設課程",
                    educational:"學歷",
                    service:"主要業務",
                },
                {
                    //名譽教授
                    PJ_ID: "PJ20250506",
                    phone: "",
                    fax: "退休",
                    email: "",
                    research:"研究領域",
                    offered:"開設課程",
                    educational:"",
                    service:"主要經歷",
                },
            ],
            //當前樣式顯示
            now_special: {},

        };
    },
    props: ["sideright", "PJ_ID"],
    mounted() {
        //初始化
        this.init();
    },
    watch: {
        "sideright"() {
            this.init();
        },
    },
    methods: {
        init() {
             this.now_special = this.special_list.find(item => item.PJ_ID == this.PJ_ID)|| {
                phone: '電話',
                fax: '傳真',
                email: 'Email',
                research: "研究領域",
                offered: "開設課程",
                educational: "學歷",
                service: "服務機關",
            };
            this.title = this.sideright.title;
            this.filepath = this.sideright.filepath;
            if(this.sideright.content != "目前尚未查詢到文章內容"){

                let json_Data = JSON.parse(this.sideright.content);
                this.job = json_Data.job || "";
                this.phone = json_Data.phone || "";
                this.fax = json_Data.fax || "";
                this.email = json_Data.email || "";
                this.research = Array.isArray(json_Data.research)? json_Data.research :[];
                this.offered = Array.isArray(json_Data.offered)?json_Data.offered:[];
                this.educational = Array.isArray(json_Data.educational)?json_Data.educational:[];
                this.service = Array.isArray(json_Data.service)?json_Data.service:[];
            }else{
                this.job =  "";
                this.phone = "";
                this.fax = "";
                this.email ="";
                this.research =[];
                this.offered = [];
                this.educational = [];
                this.service = [];
            }
        },
        //若圖片載入失敗時，切換為簡易
        handleImgError(event){
            const img = event.target;
            const fallbackUrl = new URL(
                "/images/therpc_01.jpg",
                window.location.origin
            ).href;

            // 預設圖片也載入失敗時，不再重複設定，避免循環
            if (img.src === fallbackUrl) return;

            img.src = fallbackUrl;
        },
    }
}
</script>